import controller from './card-add-contract-dialog.controller';

export default {
  controller,
  template: require('./card-add-contract-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/card-add-contract-dialog/card-add-contract-dialog.component.ts